import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  Alert,
  Dropdown,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { translateFileAPI, getLanguagesList } from "../../services/api";
import { STORAGE_KEY } from "../../utils/Constant";
import "./translatefile.css";
import {  getAllFiles } from '../../services/api';
import Home from "../Home/Home";
import mammoth from "mammoth";
 
function TranslateFile({ file, onTranslate, setShouldFetchFiles, shouldFetchFiles, setSelectedTranslatedFile }) {
  const [flag, setFlag] = useState(false);
  const [languageInput, setLanguageInput] = useState("");
  const [languageOutput, setLanguageOutput] = useState([]);
  const [fileName, setFileName] = useState(file?.name || "File name.pdf");
  const [showModal, setShowModal] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [languages, setLanguages] = useState([]);
  const [showUploadContainer, setShowUploadContainer] = useState();
  const [dashboard, setDashboard] = useState([]);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const originalPreviewRef = useRef(null)

  const renderDocxPreview = async (file, previewRef) => {
    try {
      const arrayBuffer = await file.arrayBuffer();
      const result = await mammoth.convertToHtml({ arrayBuffer });
      previewRef.current.innerHTML = result.value;
    } catch (error) {
      console.error("Error rendering DOCX file:", error);
      previewRef.current.innerHTML = '<p>Error rendering DOCX file.</p>';
    }
};
 
  useEffect(() => {
    const loadLanguages = async () => {
      try {
        const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
        const parsedData = JSON.parse(data);
        const AT = parsedData.accessToken;
        const RT = parsedData.refreshToken;
        const response = await getLanguagesList(AT, RT);
 
        if (response.status_code === 202 && Array.isArray(response.description)) {
          setLanguages(response.description);
        } else if (response.status_code === 404) {
          Swal.fire("File not with ID was not found");
        } else {
          Swal.fire("Unexpected response format");
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
        Swal.fire("Failed to fetch languages");
      }
    };
 
    loadLanguages();
  }, []);

 
  const handleTranslate = async () => {
    if (!languageInput || !languageOutput) {
      Swal.fire("Missing Fields", "Please select both input and output languages.");
      return;
    }
 
    if (languageInput === languageOutput) {
      Swal.fire("Invalid Selection", "Input and output languages cannot be the same.");
      return;
    }
 
    try {
      const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
      const parsedData = JSON.parse(data);
      const AT = parsedData.accessToken;
      const RT = parsedData.refreshToken;
      const response = await translateFileAPI(file, languageInput, languageOutput, AT, RT);
 
      if (response.status_code === 201) {
        onTranslate?.();
        setFlag(true);
        setShowModal(false);
        setShouldFetchFiles(true);
        setSelectedTranslatedFile(undefined);
        navigate("/home");
      } else if (response.status_code === 400) {
        Swal.fire("Bad Request", "File with the provided ID not found.");
      } else if (response.status_code === 413) {
        Swal.fire("Error", "Request entity too large.");
      } else if (response.status_code === 415) {
        Swal.fire("Error", "Unsupported media type.");
      } else if (response.status_code === 503) {
        Swal.fire("FMS is Down");
      } else {
        throw new Error("Translation failed");
      }
      
    } catch (error) {
  const status = error?.response?.status;

  if (status === 401) {
    Swal.fire(
      "Session Expired",
      "Please logout and login again",
      "warning"
    );
  } else if (status === 404) {
    Swal.fire(
      "Not Found",
      "Requested resource not found",
      "error"
    );
  } else {
    Swal.fire(
      "Error",
      "Translation failed. Please try again.",
      "error"
    );
  }
}
  };
  useEffect(() => {
    console.log("Flag updated:", flag);
  }, [flag]);
  const handleLanguageInputChange = (event) =>
    setLanguageInput(event.target.value);

  const handleLanguageOutputChange = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;

    setLanguageOutput((prev) => {
      if (checked) {
        return [...prev, value]; // add
      } else {
        return prev.filter((lang) => lang !== value); // remove
      }
    });
  };

  const handleClose = () => {
    setShowModal(false);
    // setUploadedFiles([]);
    navigate("/home");
    setShouldFetchFiles(false);
    setSelectedTranslatedFile(undefined);
    // window.location.reload();
  };
 
  const renderFilePreview = () => {
    if (!file) {
      return <span>No file selected</span>;
    }
 
    const fileType = file.type.split('/')[1];

     if (fileType === 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
      renderDocxPreview(file, originalPreviewRef)
      return <div ref={originalPreviewRef} style={{ height: '100%', width: '100%', overflow: 'auto' }}></div>
    }
 
    if (fileType === 'pdf') {
      return (
        <iframe
          src={URL.createObjectURL(file)}
          title={file.name}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      );
    }
 
    if (['png', 'jpeg', 'jpg'].includes(fileType)) {
      return (
        <img
          src={URL.createObjectURL(file)}
          alt={file.name}
          style={{ maxWidth: '100%', maxHeight: '100%' }}
        />
      );
    }
 
    return <span>Unsupported file type. Preview not available.</span>;
  };
 
  return (
    <div id="Translate" className="TranslateFile">
      <Modal
        show={showModal}
        onHide={handleClose}
        className="translate-modal"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Translate File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
            <Row className="mt-2">
              <Col>
                <Form.Label>Language Input</Form.Label>
                <Form.Control
                  as="select"
                  value={languageInput}
                  onChange={handleLanguageInputChange}
                >
                  <option value="">Select Input Language</option>
                  {languages.map((lang) => (
                    <option key={lang.id} value={lang.language}>
                      {lang.language}
                    </option>
                  ))}
                </Form.Control>
              </Col>
              <Col>
                <Form.Label>Language Output</Form.Label>

                <Dropdown autoClose="outside">
                  <Dropdown.Toggle
                    className="form-control text-start bg-white text-dark"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>
                      {languageOutput.length > 0
                        ? languageOutput.join(", ")
                        : "Select Output Language"}
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="w-100"
                    style={{
                      maxHeight: "200px",
                      overflowY: "auto",
                      padding: "10px",
                    }}
                  >
                    {languages.map((lang) => (
                      <Form.Check
                        key={lang.id}
                        type="checkbox"
                        label={lang.language}
                        value={lang.language}
                        checked={languageOutput.includes(lang.language)}
                        onChange={handleLanguageOutputChange}
                      />
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Form.Label>File Name</Form.Label>
                <Form.Control type="text" value={fileName} readOnly />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <div style={{
                  backgroundColor: '#ddd',
                  height: '450px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  overflow: 'hidden'
                }}>
                  {renderFilePreview()}
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleTranslate}
            disabled={!languageInput || !languageOutput}
          >
            Translate
          </Button>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={() => { }}
          />
        </Modal.Footer>
      </Modal>
      <div >
      {/* <Home  flag={flag} setFlag={setFlag} /> */}
      </div>
    </div>
  );
}
 
export default TranslateFile;